import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import ShowTermsIcon from '@mui/icons-material/Visibility';
import CancelButton from 'components/buttons/Cancel';
import ConfirmButton from 'components/buttons/Confirm';
import Card from 'components/Card';
import CardActions from 'components/Card/Actions';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Dialog from 'components/Dialog';
import RowSpacer from 'components/RowSpacer';

const styles = {
  card: {},
};

const CommunityJoinDialog = ({ community, onConfirm, onCancel, open }) => {
  const [valid, setValid] = useState(false);
  return (
    <Dialog modal onRequestClose={onCancel} open={open}>
      <Card style={styles.card}>
        <CardHeader
          titleStyle={{ fontSize: '1rem !important' }}
          title='Join this community!'
        />
        <CardText noTopPadding>
          As a member, you&apos;ll unlock exclusive opportunities like entering
          sweepstakes, receiving great offers, sampling awesome products and
          being among the first to learn about new products that are coming out!
        </CardText>
        <CardText noTopPadding>
          <FormControlLabel
            style={{ fontSize: 15 }}
            label='I agree to the Community Waiver'
            control={(
              <Checkbox
                name='terms'
                defaultChecked={false}
                onChange={useCallback((e, checked) => setValid(checked), [
                  setValid,
                ])}
              />
            )}
          />
        </CardText>
        <a
          href={`/communities/${community?.slug}/waiver`}
          target='_blank'
          rel='noopener noreferrer'
        >
          <Button color='info' fullWidth startIcon={<ShowTermsIcon />} primary>
            View Full Waiver
          </Button>
        </a>
        <CardActions noTopPadding>
          <CancelButton secondary onClick={onCancel} />
          <RowSpacer />
          <ConfirmButton
            disabled={!valid}
            label='Join'
            primary
            onClick={onConfirm}
          />
        </CardActions>
      </Card>
    </Dialog>
  );
};

CommunityJoinDialog.propTypes = {
  community: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default CommunityJoinDialog;
